import './CreatePost.scss'

import { useRef, useState } from 'react'
import Icon from '../utils/Icon'
import Flex from '../utils/Flex'
import IconClose from '../icons/IconClose'
import TWButton from '../utils/TWButton/TWButton'
import ProfileThumbImg from '../../assets/images/profile-thumb.png'
import { classify } from '../../helpers'

const initialPost = () => ({
	text: '',
	user: {
		fullName: 'RK Anik',
		username: '@rkanik',
		thumbnail: ProfileThumbImg,
	},
	images: []
})

const CreatePost = ({ className, onCreate }) => {

	const createpInput = useRef(null)
	const [post, setPost] = useState(initialPost())

	const validPost = !!post.text || post.images.length > 0

	const onAddUpload = () => {
		createpInput.current.click()
	}
	const onMediaChoose = (e) => {
		console.log(e.target.files)
		const images = [...e.target.files].map(file => {
			return URL.createObjectURL(file)
		})
		setPost({ ...post, images })
	}
	const handleCreatePost = () => {
		onCreate(post)
		setPost(initialPost())
	}

	return (
		<div className={classify("createp pt-3 md:pt-6 px-3 md:px-8 lg:px-12 bg-primary rounded", className)}>
			<Flex>
				<img
					src={ProfileThumbImg}
					alt="Profile thumbnail"
					className="w-12 h-12 md:w-16 md:h-16 rounded md:rounded-xl object-cover object-center"
				/>
				<div className="ml-3 md:ml-6 flex-auto">
					<label htmlFor="createp-textarea" className="sr-only">Create Post</label>
					<textarea
						value={post.text}
						id="createp-textarea"
						placeholder="What do you want to share?"
						className="bg-primary w-full h-full text-base xl:text-xl"
						onInput={e => setPost(p => ({ ...p, text: e.target.value }))}
					></textarea>
				</div>
			</Flex>
			<input
				multiple
				type="file"
				className="hidden"
				ref={createpInput}
				name="createp-input"
				accept="image/x-png,image/gif,image/jpeg"
				onInput={onMediaChoose}
			/>
			<Flex className="mt-11 pb-3 space-x-4">
				{post.images.map((img, mi) => (
					<div
						key={mi}
						className="relative h-12 w-12 lg:w-24 lg:h-24"
						onClick={() => { setPost(post => ({ ...post, images: post.images.splice(mi, 1) })) }}
					>
						<img
							src={img}
							alt="Create post"
							className="w-full h-full rounded lg:rounded-xl object-cover object-center"
						/>
						<div className="absolute cursor-pointer -top-2 -right-2 h-5 w-5 rounded-full bg-red-400 flex items-center justify-center">
							<Icon name="close" className="h-4 w-4">
								<IconClose />
							</Icon>
						</div>
					</div>
				))}
			</Flex>
			<hr className="createp__hr" />
			<Flex justify-between className="flex-wrap">
				<Flex items-center className="py-3">
					<TWButton onClick={onAddUpload} text size="sm">
						<i className="material-icons mr-2 text-xl">add_photo_alternate</i>
						Add Media
					</TWButton>
					<hr className="createp__bhr mx-2 md:mx-4" />
					<TWButton text size="sm">
						<i className="material-icons mr-2 text-xl">monetization_on</i>
						Create Tip Goal
					</TWButton>
				</Flex>
				<div className="py-3 ml-2 md:ml-4">
					<TWButton
						size="sm"
						color="primary"
						v-if="validPost"
						disabled={!validPost}
						onClick={handleCreatePost}
					>
						Publish Post
					</TWButton>
				</div >
			</Flex >
		</div>
	)
}

export default CreatePost
